import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Stack from "@mui/material/Stack";
import { Box, IconButton } from "@mui/material";
import { LightTooltip } from "../../LightToolTip/LightToolTip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { KeyComponentProps } from "../../../pages/MyTracks/types";
import { ToggleButtonCustomized, styles } from "./styles";

const KeyComponent: React.FC<KeyComponentProps> = ({
  songKey,
  scale,
  showKeyTooltip,
  setShowKeyTooltip,
  handleshowKeyTooltip,
  handleScale,
  handleKey,
}) => {
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ marginBottom: 4, marginTop: 2 }}
    >
      <label htmlFor="key" style={styles.stackLabel}>
        Key <span className="optional-input">(optional)</span>
        <Box
          style={{ display: "inline" }}
          onMouseOver={() => setShowKeyTooltip(true)}
          onMouseLeave={() => setShowKeyTooltip(false)}
        >
          <LightTooltip
            title="The key of a song is the note or chord the music is centered around"
            placement="top"
            open={showKeyTooltip}
            onClick={handleshowKeyTooltip}
          >
            <IconButton disableRipple>
              <HelpOutlineIcon color="info" style={{ height: 16, width: 16 }} />
            </IconButton>
          </LightTooltip>
        </Box>
      </label>
      <ToggleButtonGroup
        value={songKey}
        exclusive
        onChange={handleKey}
        aria-label="key"
      >
        <ToggleButtonCustomized
          value="C"
          aria-label="C"
          style={{ width: 50 }}
          disableRipple
        >
          C
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="D"
          aria-label="D"
          style={{ width: 50 }}
          disableRipple
        >
          D
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="E"
          aria-label="E"
          style={{ width: 50 }}
          disableRipple
        >
          E
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="F"
          aria-label="F"
          style={{ width: 50 }}
          disableRipple
        >
          F
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="G"
          aria-label="G"
          style={{ width: 50 }}
          disableRipple
        >
          G
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="A"
          aria-label="A"
          style={{ width: 50 }}
          disableRipple
        >
          A
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="B"
          aria-label="B"
          style={{ width: 50 }}
          disableRipple
        >
          B
        </ToggleButtonCustomized>
      </ToggleButtonGroup>

      <ToggleButtonGroup
        value={songKey}
        exclusive
        onChange={handleKey}
        aria-label="key sharp"
      >
        <ToggleButtonCustomized
          value="C#"
          aria-label="C sharp"
          style={{ width: 50 }}
          disableRipple
        >
          C &#x266F;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="D#"
          aria-label="D sharp"
          style={{ width: 50 }}
          disableRipple
        >
          D &#x266F;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="F#"
          aria-label="F sharp"
          style={{ width: 50 }}
          disableRipple
        >
          F &#x266F;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="G#"
          aria-label="G sharp"
          style={{ width: 50 }}
          disableRipple
        >
          G &#x266F;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="A#"
          aria-label="A sharp"
          style={{ width: 50 }}
          disableRipple
        >
          A &#x266F;
        </ToggleButtonCustomized>
      </ToggleButtonGroup>

      <ToggleButtonGroup
        value={songKey}
        exclusive
        onChange={handleKey}
        aria-label="key flat"
      >
        <ToggleButtonCustomized
          value="Db"
          aria-label="D flat"
          style={{ textTransform: "none", width: 50 }}
          disableRipple
        >
          D&#x266D;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="Eb"
          aria-label="E flat"
          style={{ textTransform: "none", width: 50 }}
          disableRipple
        >
          E&#x266D;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="Gb"
          aria-label="G flat"
          style={{ textTransform: "none", width: 50 }}
          disableRipple
        >
          G&#x266D;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="Ab"
          aria-label="A flat"
          style={{ textTransform: "none", width: 50 }}
          disableRipple
        >
          A&#x266D;
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="Bb"
          aria-label="B flat"
          style={{ textTransform: "none", width: 50 }}
          disableRipple
        >
          B&#x266D;
        </ToggleButtonCustomized>
      </ToggleButtonGroup>

      <ToggleButtonGroup value={scale} onChange={handleScale} exclusive>
        <ToggleButtonCustomized
          value="minor"
          aria-label="minor"
          style={styles.modalScale}
          disableRipple
        >
          Minor
        </ToggleButtonCustomized>
        <ToggleButtonCustomized
          value="major"
          aria-label="major"
          style={styles.modalScale}
          disableRipple
        >
          Major
        </ToggleButtonCustomized>
      </ToggleButtonGroup>
    </Stack>
  );
};

export default KeyComponent;
